import { useEffect } from 'react';

import { withServerData } from '@xingternal/hops';
import { LOGIN_STATE } from '@xingternal/hops-user-auth';

import { getLocation, redirect } from '@/helpers/location';

const FENCED_SELECTOR = '[data-soft-login-fenced]';

function closest(el, selector) {
  if (el.closest) return el.closest(selector);
  // ie11
  do {
    if (el.matches && el.matches(selector)) return el;
    el = el.parentElement || el.parentNode;
  } while (el !== null && el.nodeType === 1);

  return null;
}

function handler(event) {
  if (closest(event.target, FENCED_SELECTOR)) {
    event.stopPropagation();
    const location = getLocation();
    redirect(
      `${location.protocol}//login.${location.hostname.replace('www.', '')}/continue?dest_url=${location.pathname}${
        location.search
      }${location.hash}`
    );
  }
}

export default withServerData(({ children, serverData }) => {
  useEffect(() => {
    if (serverData.loginState === LOGIN_STATE.SOFT_LOGGED_IN) {
      document.addEventListener('click', handler, { capture: true });
      return () => {
        document.removeEventListener('click', handler, { capture: true });
      };
    }
  });

  return children;
});
